import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class BroadcastChannelStore extends LocalModel {
    constructor() {
        super('broadcastChannel', {
            namePlural: 'broadcastChannels',
            namePluralReal: 'broadcastchannels',
            sort: 'sortOrder',
            limit: 100,
            api: {
                search: {
                    url: '/api/broadcastchannels/',
                    params: {
                        limit: 100,
                        sort: 'sortOrder',
                    },
                },
                load: {
                    url: '/api/broadcastchannels/',
                    params: {},
                },
                save: {
                    url: '/api/broadcastchannels/',
                    params: {},
                },
                delete: {
                    url: '/api/broadcastchannels/',
                    params: {},
                },
            },
        });
    }

    @observable newBroadcastChannel = {};

    @observable broadcastChannel = {};

    @observable broadcastChannels = [];

    @observable selectedChannelId = null;

    @observable selectedChannelIds = [];

    @action
    setSelectedChannel(channelId) {
        this.selectedChannelId = channelId;
    }

    @action
    setSelectedChannels(channelIds, skipSave = false) {
        this.selectedChannelIds = channelIds || [];
        // Keep single selection in sync (use first selected)
        this.selectedChannelId = channelIds?.length > 0 ? channelIds[0] : null;
        // Save to localStorage
        if (!skipSave) {
            localStorage.setItem('tvRadioProducerSelectedChannels', JSON.stringify(this.selectedChannelIds));
        }
    }

    @action
    restoreSelectedChannels(availableChannelIds) {
        const savedChannels = localStorage.getItem('tvRadioProducerSelectedChannels');
        if (savedChannels) {
            try {
                const parsedChannels = JSON.parse(savedChannels);
                const validChannels = parsedChannels
                    .map(id => parseInt(id, 10))
                    .filter(id => availableChannelIds.includes(id));
                if (validChannels.length > 0) {
                    this.setSelectedChannels(validChannels, true);
                    return true;
                }
            } catch (e) {
                // Invalid JSON, ignore
            }
        }
        return false;
    }

    @action
    async loadChannels(race) {
        try {
            const params = {};
            if (race) {
                params.race = race;
            }
            const response = await util.fetchApi('/api/broadcastchannels/', { method: 'GET' }, params);
            if (response && response.status === 200) {
                this.updateKeyValue('broadcastChannels', response.data || []);
                return response.data;
            }
        } catch (err) {
            console.error('Error loading broadcast channels:', err);
        }
        return [];
    }
}

const store = new BroadcastChannelStore();
export default store;
